import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faWhatsapp, faTelegram, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { LoadingGeminiState, EmptyState } from './LoadingGeminiStates';
import './Popups.css';

export const URLAnalyzerPopup = ({ isOpen, onClose, formattedDate, formattedTime }) => {
    const [url, setUrl] = useState('');
    const [analyzeResult, setAnalyzeResult] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    if (!isOpen) return null;

    const isValidUrl = (string) => {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    };

    const handleAnalyze = async () => {
        if (!isValidUrl(url)) {
            setAnalyzeResult('Invalid URL. Please enter a valid URL.');
            setHasError(true);
            return;
        }

        setIsLoading(true);
        setHasError(false);
        try {
            const response = await fetch('http://localhost:5000/api/rss/analyzeUrl', {
                // const response = await fetch('/.netlify/functions/analyzeUrl', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ url }),
            });

            const data = await response.json();
            if (data.error) {
                setHasError(true);
                setAnalyzeResult(`Error: ${data.error}`);
            } else {
                setAnalyzeResult(data.analysis);
            }
        } catch (error) {
            console.error('Error analyzing URL:', error);
            setHasError(true);
            setAnalyzeResult('Failed to analyze the URL. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleShare = (platform) => {
        const shareText = `Hasil Analisis Berita:\n${analyzeResult} \n\nDibagikan melalui: Selidik | ${decodeURIComponent(window.location.href)} | Diperbarui: ${formattedDate} ${formattedTime}`;
        const encodedText = encodeURIComponent(shareText);

        switch (platform) {
            case 'whatsapp':
                window.open(`https://api.whatsapp.com/send?text=${encodedText}`, '_blank');
                break;
            case 'twitter':
                window.open(`https://twitter.com/intent/tweet?text=${encodedText}`, '_blank');
                break;
            case 'facebook':
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}&quote=${encodedText}`, '_blank');
                break;
            case 'telegram':
                window.open(`https://t.me/share/url?url=${encodeURIComponent(window.location.href)}&text=${encodedText}`, '_blank');
                break;
            case 'email':
                window.open(`mailto:?subject=Hasil Analisis Berita&body=${encodedText}`, '_blank');
                break;
            default:
                break;
        }
    };

    const renderContent = () => {
        if (isLoading) {
            return <LoadingGeminiState />;
        }

        if (hasError && !analyzeResult) {
            return <EmptyState />;
        }

        if (analyzeResult) {
            return (
                <div className="analysis-result">
                    <pre>{analyzeResult}</pre>
                    <p className="timestamp"><strong>🕒 Diperbarui:</strong> {formattedDate} | {formattedTime}</p>
                    <div className="share-buttons">
                        <button onClick={() => handleShare('whatsapp')} className="whatsapp">
                            <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp
                        </button>
                        <button onClick={() => handleShare('twitter')} className="twitter">
                            <FontAwesomeIcon icon={faXTwitter} /> X
                        </button>
                        <button onClick={() => handleShare('facebook')} className="facebook">
                            <FontAwesomeIcon icon={faFacebook} /> Facebook
                        </button>
                        <button onClick={() => handleShare('telegram')} className="telegram">
                            <FontAwesomeIcon icon={faTelegram} /> Telegram
                        </button>
                        <button onClick={() => handleShare('email')} className="email">
                            <FontAwesomeIcon icon={faEnvelope} /> Email
                        </button>
                    </div>
                </div>
            );
        }

        return null;
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <div className="popup-header">
                    <h2>Selidik URL</h2>
                    <button className="close-button" onClick={onClose}>Tutup</button>
                </div>
                <div className="popup-body">
                    <div className="url-input-container">
                        <input
                            type="text"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            disabled={isLoading}
                            placeholder="Masukkan URL valid"
                        />
                        <div className="button-group">
                            <button
                                onClick={() => setUrl('')}
                                disabled={isLoading}
                                className="clear-button"
                            >
                                Bersihkan
                            </button>
                            <button
                                onClick={handleAnalyze}
                                disabled={isLoading}
                                className="analyze-button"
                            >
                                {isLoading ? 'Menyelidiki...✨' : 'Selidik ✨'}
                            </button>
                        </div>
                    </div>
                    {renderContent()}
                </div>
            </div>
        </div>
    );
};

export default URLAnalyzerPopup;